const campaignCategories = {
  firmwareUpdate: "FIRMWARE_UPDATE",
  loyalty: "LOYALTY",
  informative: "INFORMATIVE",
  marketing: "MARKETING",
  conversion: "CONVERSION",
  system: "SYSTEM"
};

export default campaignCategories;
